/**
 * Animación de despliegue para los acordeones (`<transition>` con hooks JS).
 */

export const COLLAPSE_TRANSITION_MS = 300;

const TRANSITION = `height ${COLLAPSE_TRANSITION_MS}ms ease, opacity ${COLLAPSE_TRANSITION_MS}ms ease, margin-top ${COLLAPSE_TRANSITION_MS}ms ease`;

function forceReflow (element) {
    return element.offsetHeight;
}

export function expand (element, marginTop = '0') {
    element.style.height = '0';
    element.style.opacity = '0';
    element.style.overflow = 'hidden';
    element.style.marginTop = '0';
    forceReflow(element);
    element.style.transition = TRANSITION;
    element.style.height = `${element.scrollHeight}px`;
    element.style.opacity = '1';
    element.style.marginTop = marginTop;
}

export function collapse (element, marginTop = '0') {
    element.style.height = `${element.scrollHeight}px`;
    element.style.overflow = 'hidden';
    element.style.marginTop = marginTop;
    forceReflow(element);
    element.style.transition = TRANSITION;
    element.style.height = '0';
    element.style.opacity = '0';
    element.style.marginTop = '0';
}

export function settle (element) {
    element.style.height = 'auto';
    element.style.opacity = '1';
    element.style.overflow = 'visible';
    element.style.transition = 'none';
    element.style.marginTop = '';
}
